import styled from 'styled-components';

export const IconWrapper = styled.div<{ $active: boolean }>`
  display: flex;
  height: 100%;
  align-items: baseline;

  svg {
    display: block;
    margin: auto;
    width: 24px;
    will-change: transform;
    transition: transform 150ms ease-in-out;
    pointer-events: none;
    transform: ${({ $active }): string => ($active ? `rotate(180deg) ` : '')};
  }
`;
